module.exports = __webpack_public_path__ + "img/symbol_3.d42f52d0.png";